import { render, staticRenderFns } from "./BulkEditForm.vue?vue&type=template&id=4c3c130f&lang=pug"
import script from "./BulkEditForm.vue?vue&type=script&lang=js"
export * from "./BulkEditForm.vue?vue&type=script&lang=js"
import style0 from "./BulkEditForm.vue?vue&type=style&index=0&id=4c3c130f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports